module.exports = __webpack_public_path__ + "static/media/idea-vision-visualization.66a85e5e.png";